export default __webpack_public_path__ + "static/media/op.34412af2.svg";